"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/UI/Card";
// import { ScrollArea } from "~/components/UI/ScrollArea";
// import Step from "./components/Step";
import AnimatedStep from "./components/Step/Animated";
import type { IStep } from "./types";
import { type ReactNode, useRef } from "react";
import { cn } from "~/lib/utils";
import useIsIntersecting from "~/lib/hooks/is-intersecting";

export default function HowItWorksSection(props: {
  steps: IStep[];
  title: ReactNode;
  description: string;
  className?: string;
  theme?: "dark";
  id: string;
}) {
  const headRef = useRef<HTMLHeadingElement>(null);
  const descriptionRef = useRef<HTMLParagraphElement>(null);
  // const longestStepItem = useMemo(() => {
  //   if (props.steps[props.steps.length - 1]?.cta) {
  //     return props.steps[props.steps.length - 1];
  //   }

  //   return props.steps.reduce(
  //     (acc, item) =>
  //       acc && item.description.length > acc.description.length ? item : acc,
  //     props.steps[0],
  //   );
  // }, [props.steps]);

  const isHeaderIntersecting = useIsIntersecting({
    ref: headRef,
    intersectionObserverInit: {
      threshold: 0.25,
    },
  });
  const isDescriptionIntersecting = useIsIntersecting({
    ref: descriptionRef,
    intersectionObserverInit: {
      threshold: 0.25,
    },
  });

  return (
    <Card
      id={props.id}
      size="lg"
      as="section"
      edges={null}
      className={cn(
        "gap-y-8 bg-transparent md:gap-0 max-sm:text-center max-sm:items-center",
        props.theme === "dark" && "dark bg-primary",
        props.className,
      )}
    >
      <CardHeader className="mx-auto max-w-[1400px] w-full">
        <CardTitle
          as="h2"
          className={cn(
            "font-minion-pro text-4xl.5",
            "transition-opacity duration-700 ease-in-out delay-300",
            isHeaderIntersecting ? "opacity-100" : "opacity-0",
          )}
          ref={headRef}
        >
          {props.title}
        </CardTitle>
        <CardDescription
          className={cn(
            "max-w-[450px] text-lg",
            "transition-opacity duration-700 ease-in-out delay-300",
            isDescriptionIntersecting ? "opacity-100" : "opacity-0",
          )}
          ref={descriptionRef}
        >
          {props.description}
        </CardDescription>
      </CardHeader>
      <CardContent
        size="none"
        className="relative isolate z-[1] mx-auto max-w-[1400px] w-full"
      >
        {/* <div className="pointer-events-none select-none opacity-0">
          {!longestStepItem ? null : (
            <div className="py-8">
              <Step
                index={3}
                title={longestStepItem.title}
                description={longestStepItem.description}
                icon={longestStepItem.icon}
                img={longestStepItem.img}
                theme={props.theme}
              />
            </div>
          )}
        </div> */}
        <div className=" inset-0">
          {/* <ScrollArea
            className="h-full min-h-fit w-full isolate"
            scrollBar={{ className: "opacity-0" }}
          > */}
            <div
              className="absolute top-0 inset-x-0 py-8"
              style={{
                background:
                  props.theme === "dark"
                    ? `linear-gradient(180deg, hsla(var(--primary) / 1), hsla(var(--primary) / 0))`
                    : `linear-gradient(180deg, hsla(var(--background) / 1), hsla(var(--background) / 0))`,
                zIndex: 2,
              }}
            />
            <div className="flex flex-col gap-x-4 p-4 relative">
              {props.steps.map((item, index) => (
                <AnimatedStep
                  index={index}
                  key={item.title}
                  {...item}
                  theme={props.theme}
                />
              ))}
            </div>
            <div
              className="absolute bottom-0 inset-x-0 py-8"
              style={{
                background:
                  props.theme === "dark"
                    ? `linear-gradient(0deg, hsla(var(--primary) / 1), hsla(var(--primary) / 0))`
                    : `linear-gradient(0deg, hsla(var(--background) / 1), hsla(var(--background) / 0))`,
                zIndex: 2,
              }}
            />
          {/* </ScrollArea> */}
        </div>
      </CardContent>
    </Card>
  );
}
